module.exports = __webpack_public_path__ + "static/media/cashPayment.7679d55b.svg";